/**
 * Rutas donde el topbar muestra Abrir/Cerrar turno (`app-pos-header-ops`).
 *
 * Incluye shell POS y módulo Ventas del tenant (Pedidos + Configuración),
 * sin forzar el layout fullbleed de canvas (`isTenantEmbeddedPosCanvasPath`).
 */
export function shouldShowPosHeaderOpsPath(urlOrPath: string): boolean {
  const path = (urlOrPath.split('?')[0] || '').trim().replace(/\/+$/, '') || '/';

  if (path === '/pos' || path.startsWith('/pos/')) {
    return true;
  }
  if (path === '/sales/pos' || path.startsWith('/sales/pos/')) {
    return true;
  }
  if (path === '/sales/orders' || path.startsWith('/sales/orders/')) {
    return true;
  }
  if (path === '/sales/configuracion' || path.startsWith('/sales/configuracion/')) {
    return true;
  }
  return false;
}
